import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* 상단 공지 바 */}
      <div className="w-full bg-gray-100 text-center text-xs py-2 text-gray-600 fixed top-0 left-0 z-50">
        * 대구 / 경북 지역 한정, 무료 주방 가구 견적 서비스 진행 중입니다.
      </div>

      {/* 메인 네비게이션 */}
      <header
        className={`fixed top-8 left-0 w-full z-40 transition-all duration-300 ${
          scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          {/* 로고 */}
          <a href="/" className="flex-shrink-0">
            <span className="text-lg font-black text-gray-900 tracking-tight whitespace-nowrap">
              대구싱크대 키친스
            </span>
          </a>

          {/* 데스크탑 메뉴 */}
          <nav className="hidden md:flex items-center gap-8">
            <a
              href="/kitchendesignprice"
              className="text-sm font-medium text-gray-800 hover:text-yellow-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              무료 견적 신청
            </a>
            <a
              href="https://blog.naver.com/hanskid"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-sm font-medium text-gray-800 hover:text-yellow-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-article-line text-base"></i>
              블로그 바로가기
            </a>
            <a
              href="tel:010-4016-8890"
              className="text-sm font-medium text-gray-800 hover:text-yellow-500 transition-colors whitespace-nowrap cursor-pointer"
            >
              ☎ 010-4016-8890
            </a>

          </nav>

          {/* 모바일 햄버거 */}
          <button
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`text-xl text-gray-800 ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* 모바일 메뉴 */}
        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
            <a
              href="/kitchendesignprice"
              className="text-sm font-medium text-gray-800 py-2 border-b border-gray-100 cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              무료 견적 신청
            </a>
            <a
              href="https://blog.naver.com/hanskid"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-medium text-gray-800 py-2 border-b border-gray-100 cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              <i className="ri-article-line text-base"></i>
              블로그 바로가기
            </a>
            <a
              href="tel:010-4016-8890"
              className="text-sm font-medium text-gray-800 py-2 cursor-pointer"
              onClick={() => setMobileOpen(false)}
            >
              ☎ 010-4016-8890
            </a>
          </div>
        )}
      </header>
    </>
  );
}
